import {
    CERTIFICATES_GENERATE_TOKEN,
    CERTIFICATES_GENERATE_TOKEN_RESULT,
    CERTIFICATES_DOWNLOAD,
    CERTIFICATES_DOWNLOAD_RESULT,
    CERTIFICATES_SET_LOADING
} from './actionTypes';

export const certificatesGenerateToken = (certificateType) => ({
    type: CERTIFICATES_GENERATE_TOKEN,
    payload: certificateType
});

export const certificatesGenerateTokenResult = (token) => ({
    type: CERTIFICATES_GENERATE_TOKEN_RESULT,
    payload: token
});

export const certificatesDownload = (token, certificateType) => ({
    type: CERTIFICATES_DOWNLOAD,
    payload: { token, certificateType }
});

export const certificatesDownloadResult = (data) => ({
    type: CERTIFICATES_DOWNLOAD_RESULT,
    payload: data
});

export const certificatesSetLoading = (loading) => ({
    type: CERTIFICATES_SET_LOADING,
    payload: loading
});